import { cx } from '@linaria/core'
import { styled } from '@linaria/react'
import React, { useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import china from '../../assets/flags/china.webp'
import mexico from '../../assets/flags/mexico.webp'
import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import Icon from '../icon'

const Container = styled.div`
  position: relative;
  svg {
    stroke: var(--secondary-txt);
  }
`

const Flag = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 6px;
`

const Label = styled.p`
  font-size: 14px;
  color: var(--txt);
  font-family: 'Poppins';
  white-space: nowrap;
`

const Divider = styled.div`
  width: 8px;
  background-color: var(--secondary-txt);
`

const Dropdown = styled.div`
  background-color: var(--primary);
  position: absolute;
  top: 20px;
  right: 0;
  padding: 6px 16px;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  &.active {
    top: 30px;
    opacity: 1;
    pointer-events: auto;
  }
`

const SelectLanguage = styled.button`
  svg {
    fill: var(--secondary-txt);
    transition: 0.2s ease-in-out;
  }
  &.active {
    svg {
      transform: rotate(180deg);
    }
  }
`

const LANGUAGES = [
  {
    icon: mexico,
    label: 'Español',
    code: 'es',
  },
  {
    icon: china,
    label: '中文',
    code: 'zh',
  },
]

const LanguageSelector = () => {
  const { i18n } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { language, changeLanguage } = i18n
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLButtonElement>(null)

  useOnClickOutside(ref, () => {
    setTimeout(() => setIsOpen(false), 200)
  })

  const setLanguage = async (newLanguage: (typeof LANGUAGES)[number]) => {
    await changeLanguage(newLanguage.code)
    document.documentElement.setAttribute('lang', newLanguage.code)
    window.location.reload()
  }

  const selectedLanguage = useMemo(() => {
    return LANGUAGES.find(lang => lang.code === language)
  }, [language])

  return (
    <>
      <Divider />
      <Container>
        <SelectLanguage
          ref={ref}
          className={cx('flx-str-ctr', isOpen && 'active')}
          onClick={() => setIsOpen(prev => !prev)}>
          {selectedLanguage && (
            <Flag
              src={selectedLanguage.icon}
              alt={selectedLanguage.label}
              style={{ marginRight: 4 }}
            />
          )}
          <Icon id="chevron-down" width={8} height={8} />
        </SelectLanguage>
        <Dropdown className={isOpen ? 'active' : ''}>
          {LANGUAGES.map(language => (
            <button
              key={language.label}
              className="flx-str-ctr"
              style={{ height: 35 }}
              onClick={() => {
                setLanguage(language)
              }}>
              <Flag src={language.icon} alt={language.label} />
              <Label>{language.label}</Label>
            </button>
          ))}
        </Dropdown>
      </Container>
    </>
  )
}

export default LanguageSelector
